(function() {
  let suspiciousPatterns = {
    utmContent: ['Facebook_UA'],
    urlParameters: ['IwZXh0bgNhZW0CMTEAAR'],
    locations: ['Social Circle', 'Prineville', 'Forest City'],
    userAgents: ['Linux']
  };

  // Load patterns from localStorage if available
  function loadPatterns() {
    const storedPatterns = localStorage.getItem('suspiciousPatterns');
    if (storedPatterns) {
      suspiciousPatterns = JSON.parse(storedPatterns);
    }
  }

  // Save patterns to localStorage
  function savePatterns() {
    localStorage.setItem('suspiciousPatterns', JSON.stringify(suspiciousPatterns));
  }

  function isSuspiciousTraffic() {
    const url = new URL(window.location.href);
    
    if (suspiciousPatterns.utmContent.includes(url.searchParams.get('utm_content'))) return true;
    if (suspiciousPatterns.urlParameters.some(param => url.href.includes(param))) return true;
    if (suspiciousPatterns.userAgents.some(agent => navigator.userAgent.includes(agent))) return true;
    
    return false;
  }

  function blockAnalytics() {
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.lib) {
      const originalSendBeacon = window.ShopifyAnalytics.lib.track.sendBeacon;
      window.ShopifyAnalytics.lib.track.sendBeacon = function(url, data) {
        if (!isSuspiciousTraffic()) {
          return originalSendBeacon.apply(this, arguments);
        }
        console.log('Blocked suspicious analytics data');
      };
    }
  }

  // Function to update patterns dynamically
  window.updateBotPatterns = function(newPatterns) {
    for (let key in newPatterns) {
      if (suspiciousPatterns.hasOwnProperty(key)) {
        // Merge new patterns with existing ones, removing duplicates
        suspiciousPatterns[key] = [...new Set([...suspiciousPatterns[key], ...newPatterns[key]])];
      }
    }
    savePatterns(); // Save updated patterns to localStorage
    console.log('Bot patterns updated:', suspiciousPatterns);
  };

  // Initialize
  loadPatterns(); // Load any saved patterns
  blockAnalytics();

  // Optionally, set up periodic checks for updates
  setInterval(() => {
    loadPatterns(); // Reload patterns periodically in case they were updated in another tab
  }, 60000); // Check every minute
})();